module.exports = __webpack_public_path__ + "img/202310_04.df383e39.jpg";